import { render, staticRenderFns } from "./ChangeStatusNpaDlg.vue?vue&type=template&id=623faed8"
import script from "./ChangeStatusNpaDlg.vue?vue&type=script&lang=js"
export * from "./ChangeStatusNpaDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports